// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"styles_tableBody__2g4RZ","actions":"styles_actions__ZIRNt","compactTable":"styles_compactTable__eBJtr"};